import { z } from 'zod';

const value = z.string().trim().min(1).max(60);

/** A non-empty list of distinct values (positions, species, range types, regions). */
const valueSet = z
  .array(value)
  .min(1, 'at least one value is required')
  .max(12)
  .refine((v) => new Set(v).size === v.length, 'values must be distinct');

/** Optional alternative search names. Its own export so edits can omit it without a default. */
export const aliasListSchema = z.array(value).max(10);

export const CHAMPION_ID_PATTERN = /^[A-Za-z0-9]{1,40}$/;

/** What an admin (or the seed) may write for a champion. The shape the database stores. */
export const championInputSchema = z.object({
  id: z.string().regex(CHAMPION_ID_PATTERN, 'id must be letters and digits only'),
  name: z.string().trim().min(1).max(60),
  aliases: aliasListSchema.default([]),
  gender: value,
  positions: valueSet,
  species: valueSet,
  resource: value,
  rangeType: valueSet,
  regions: valueSet,
  releaseYear: z.number().int().min(2009).max(2100),
});

export type ChampionInput = z.infer<typeof championInputSchema>;

export const ATTRIBUTE_KINDS = [
  'gender',
  'position',
  'species',
  'resource',
  'range_type',
  'region',
] as const;
export type AttributeKind = (typeof ATTRIBUTE_KINDS)[number];
